import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PolicyHeaderComponent } from '../policy-header/policy-header.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-terms-condition',
    imports: [RouterModule, PolicyHeaderComponent, CommonModule],
    templateUrl: './terms-condition.component.html',
    styleUrl: '../policy-page.css'
})
export class TermsConditionComponent {
  isLogin = false;
  ngOnInit() {
    this.isLogin = localStorage.getItem('isLogedIn') === 'true';
  }
}
